import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'
import {
  CheckAction,
  ChangeAccountDetailTemplateParameters,
} from '@app/shared/types/sf-data'

export function changeAccountDetailTemplate(action: CheckAction): void {
  const parameters = action.parameters as ChangeAccountDetailTemplateParameters

  window.modalCitizen.openModal(
    'confirm-change-account-detail-template-modal',
    {
      onConfirm: () => {
        performActionWithUnreviewConfirmation(parameters)
      },
      action,
    }
  )
}

function performActionWithUnreviewConfirmation(
  parameters: ChangeAccountDetailTemplateParameters
): void {
  window.eventHub.$emit('confirmUnreviewTemplate', {
    callback: () => {
      void performAction(parameters)
    },
  })
}

async function performAction(
  parameters: ChangeAccountDetailTemplateParameters
): Promise<void> {
  const body = new URLSearchParams({
    'account[account_detail_template_id]':
      parameters.suggestedTemplateId.toString(),
    context_account_entry_id: parameters.accountEntryId.toString(),
  })

  try {
    await SFetch.raw(parameters.actionPath, {
      method: 'PATCH',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body,
    })
  } catch (error) {
    SfLog.warn('Request failed', { error })
    return
  }

  window.Turbolinks.visit(window.location.toString())
}
